import {useEffect, useState} from "react";
import {PharmacyModel} from "../../../models/Pharmacy.model";
import http from "../../../shared/utils/http";

export default function useFestiveCalendar(pharmacy: PharmacyModel | undefined) {
    const [holidays, setHolidays] = useState<string[]>([])
    useEffect(() => {
        setHolidays([])
        pharmacy && http.get<{holidays: {day: number, month: number, year: number, all?: boolean, idPharmacy?: string}[]}>(`pharmacies/${pharmacy?.idDocument}/holidays`).then(res => {
           setHolidays(res.holidays.map(ele => `${ele.year}-${ele.month}-${ele.day}`))
        })
    }, [pharmacy]);
    const dayCellClassNames = (dateInfo: any) => {
        const d = dateInfo.date;
        const dateStr = `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
        if (dateInfo.date.getDay() === 0) {
            // Domenica
            return ['sunday-cell'];
        } else if (holidays.includes(dateStr)) {
            // Festività
            return ['holiday-cell'];
        }
        return [];
    }
    return {
        dayCellClassNames
    };
}
